import { Scope } from '../configs/shared';

export const labels = {
  id: 'labels',
  name: _TL_('Labels'),
  description: _TL_('Organize your campaigns, ad groups, and more with labels.'),
  route: 'labels',
  oldUIScope: [Scope.Account, Scope.Customer],
  scope: [Scope.Account, Scope.Customer],
  children: [
    {
      id: 'labels',
      name: _TL_('Labels'),
      route: 'labels',
    }],
};
